import styled from 'styled-components';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

export const AvatarContainer = styled.div`
    display: flex;
    height: 2.5rem;
    width: 2.5rem;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: rgb(95, 83, 220);
    flex-shrink: 0;
    overflow: hidden;

    svg {
        height: 1.25rem;
        width: 1.25rem;
        color: white;
        flex-shrink: 0;
    }
`;

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    flex: 1;
    overflow: hidden;
`;

export const UserName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
    font-weight: 600;
    color: hsl(var(--sidebar-foreground));
`;

export const UserLabel = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.75rem;
    color: hsl(var(--sidebar-foreground) / 0.7);
`;

export const MenuItem = styled(DropdownMenuItem)`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    cursor: pointer;
`;

export const LogoutItem = styled(DropdownMenuItem)`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    cursor: pointer;
    color: hsl(var(--destructive));

    &:hover {
        background-color: hsl(var(--destructive) / 0.1);
        color: hsl(var(--destructive));
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
